/** The 3-verdict annotation control. Replaces the old adopt/edit/no_fix/skip set. */
export interface VerdictAction {
  action: "no_fix" | "edit" | "skip";
  label: string;
  requiresAfter: boolean;
  variant: "secondary" | "primary" | "ghost";
}

export const VERDICT_ACTIONS: VerdictAction[] = [
  { action: "no_fix", label: "模型通过", requiresAfter: false, variant: "secondary" },
  { action: "edit", label: "修正存为种子", requiresAfter: true, variant: "primary" },
  { action: "skip", label: "跳过", requiresAfter: false, variant: "ghost" }
];
